/**
 * How a sheet primitive gets its accent — one rule for the whole directory.
 *
 * The accent is a CSS custom property (`--sheet-accent`) rather than a prop the
 * callers must thread through every part: a widget hands the chrome its accent
 * once and every chip, slider, stepper and tile inside the sheet paints with it.
 * A primitive that carries its own `accent` prop writes the same property on its
 * own root, so it wins over the inherited one for its own subtree — that is how
 * a body overrides the sheet's colour for one row (a red "boost" chip on a blue
 * fan sheet) without the chrome knowing.
 *
 * When nothing sets the property the fallback is the light accent
 * (`--device-color-light`) — the sheet's own default, and the same default the
 * chrome advertises.
 */

/** The property every primitive reads — and the chrome writes. */
export const SHEET_ACCENT_VAR = '--sheet-accent';

/** The inline style that hands this primitive's accent down to its subtree. */
export function sheetAccentStyle(accent?: string): Record<string, string> {
  return accent ? { [SHEET_ACCENT_VAR]: accent } : {};
}
